import IPropertyVisitor from "./IFieldVisitor";

import IField, {FieldType} from "./IField";
import TextField from "./Fields/TextField";
import ArrayField from "./Fields/ArrayField";
import EnumField from "./Fields/EnumField";
import LengthIntervalField from "./Fields/LengthIntervalField";
import ImageField from "./Fields/ImageField";
import BooleanField from "./Fields/BooleanField";

export default abstract class AbstractFieldVisitor<T> implements IPropertyVisitor<T> {
    public visit(field: IField): any {
        switch (field.type as FieldType) {
            case FieldType.Text:
                return this.visitTextField(field as TextField);
            case FieldType.Array:
                return this.visitArrayField(field as ArrayField);
            case FieldType.Enum:
                return this.visitEnumField(field as EnumField);
            case FieldType.LengthInterval:
                return this.visitLengthIntervalField(field as LengthIntervalField);
            case FieldType.Image:
                return this.visitImageField(field as ImageField);
            case FieldType.Boolean:
                return this.visitBooleanField(field as BooleanField);
        }
        throw new Error("Unsupported type");
    }

    protected abstract visitTextField(field: TextField): T;

    protected abstract visitArrayField(field: ArrayField): T;

    protected abstract visitEnumField(field: EnumField): T;

    protected abstract visitLengthIntervalField(field: LengthIntervalField): T;
    
    protected abstract visitImageField(field: ImageField): T;

    protected abstract visitBooleanField(field1: BooleanField): T;

}



// WEBPACK FOOTER //
// ./src/metamodel/AbstractFieldVisitor.ts